import React from 'react'
import './dashboard.css'

const Websitedashboard = ({urole, page}) => {
  return (
    <div className='appr-web-dashboard-container'>
      Dashboard
    </div>
  )
}

export default Websitedashboard